import { Box, Skeleton } from "@mui/material";
import React from "react";

const ChatSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        backgroundColor: "#F8F9FA",
        padding: "20px 40px",
        boxSizing: "border-box",
      }}
    >
      {/* Left Sidebar Skeleton */}
      <Box
        sx={{
          width: "25%",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Skeleton variant="rectangular" width="100%" height={180} sx={{ borderRadius: "10px" }} />
        <Skeleton variant="text" sx={{ mt: 2, height: 30, width: "80%" }} />
        <Skeleton variant="text" sx={{ mt: 1, height: 15, width: "90%" }} />
        <Skeleton variant="text" sx={{ mt: 1, height: 15, width: "70%" }} />
      </Box>

      {/* Chat Section Skeleton */}
      <Box
        sx={{
          flex: 2,
          backgroundColor: "white",
          borderRadius: "10px",
          backgroundColor: "#E9F4FB",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
        }}
      >
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          {/* Chat Bubbles Skeleton */}
          {[1, 2, 3, 4, 5].map((i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: i % 2 === 0 ? "flex-end" : "flex-start",
                gap: "8px",
                mt: 2,
              }}
            >
              <Skeleton
                variant="rectangular"
                sx={{
                  backgroundColor: i % 2 === 0 ? "#0073b1" : "#E0E0E0",
                  borderRadius: "12px",
                  maxWidth: "60%",
                  padding: "10px",
                  minHeight: "40px",
                  width: `50%`, 
                }}
              />
            </Box>
          ))}
        </Box>

        {/* Input Field Skeleton */}
        <Skeleton variant="rectangular" height={50} width="100%" sx={{ borderRadius: "8px" }} />
      </Box>
    </Box>
  );
};

export default ChatSkeleton;
